<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit Bank Account</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ company.name }}</div>
                    <div><span class="text-muted">Bank Account: </span>{{ bankAccount.name }}</div>
                </div>
            </div>

            <bank-account-form
                ref="bankAccountForm"
                :initial-value="formData"
            />

        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import BankAccountForm from './BankAccountForm'

export default {
    props: ['client', 'bankAccount', ],
    mixins: [FormMixin, ModalMixin],
    components: {BankAccountForm, },
    emits: ['updated', 'close', ],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.bankAccount.company_id)
        },
    },
    methods: {
        makeFormData() {
            return {
                name: this.bankAccount.name,
                name_on_account: this.bankAccount.name_on_account,
                routing_number: this.bankAccount.routing_number,
                account_number: '',
                account_number_last_4: this.bankAccount.account_number_last_4,
                check_number: this.bankAccount.check_number,
                address_1: this.bankAccount.address_1,
                address_2: this.bankAccount.address_2,
                city: this.bankAccount.city,
                state: this.bankAccount.state,
                postal_code: this.bankAccount.postal_code,
                is_default_billing: this.bankAccount.is_default_billing,
                is_default_net_pay: this.bankAccount.is_default_net_pay,
                is_default_taxes: this.bankAccount.is_default_taxes,
            }
        },
        onSubmit() {
            if (!this.$refs.bankAccountForm.validate()) {
                this.formErrors = this.$refs.bankAccountForm.formErrors
                return
            }

            const data = this.$refs.bankAccountForm.getFormData()

            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/settings/bank-accounts/${this.bankAccount.id}`
            this.$api.put(url, data).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully saved bank account details.`)
                this.$emit('updated', resp)
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.formErrors = (errors.__all__ || [])
                this.$bus.showError(errors.__all__)
            })
        }
    }
}
</script>
